"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNearAmount = exports.formatNearAmount = exports.NEAR_NOMINATION_EXP = exports.NEAR_NOMINATION = void 0;
var utils_1 = require("@near-js/utils");
Object.defineProperty(exports, "NEAR_NOMINATION", { enumerable: true, get: function () { return utils_1.NEAR_NOMINATION; } });
Object.defineProperty(exports, "NEAR_NOMINATION_EXP", { enumerable: true, get: function () { return utils_1.NEAR_NOMINATION_EXP; } });
Object.defineProperty(exports, "formatNearAmount", { enumerable: true, get: function () { return utils_1.formatNearAmount; } });
Object.defineProperty(exports, "parseNearAmount", { enumerable: true, get: function () { return utils_1.parseNearAmount; } });
